// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mJ34D","right":"styles_right__Xfy33"};